import React, { useState } from "react";
import { Flex } from "@chakra-ui/react";
import ReservationsHeader from "./ReservationsHeader";
import ReservationMonthSummary from "./ReservationMonthSummary";
import ReservationsTable from "./ReservationsTable";
import ReservationDetailDrawer from "./ReservationDetailDrawer";
import useLastReservations from "./hooks/useLastReservations";

/**
 * Admin page for browsing the 10 most recent reservations.
 * The API exposes no /list paginated, /<id> single fetch or /search endpoint,
 * so this view is intentionally a snapshot — see the API gap notes in the PR.
 * Stats below the header come from /admin/reservation/income_month (current month).
 * @returns {React.ReactElement}
 */
function Reservations() {
  const [selected, setSelected] = useState(null);
  const { items, loading, error } = useLastReservations();

  return (
    <Flex direction="column" gap="20px">
      <ReservationsHeader count={items.length} />
      <ReservationMonthSummary />
      <ReservationsTable items={items} loading={loading} error={error} onSelect={setSelected} />
      <ReservationDetailDrawer reservation={selected} onClose={() => setSelected(null)} />
    </Flex>
  );
}

export default Reservations;
